import React from 'react'

const Placeholder = () => {
    return (
        <div className="border border-gray-300 shadow rounded-md p-4 max-w-sm w-full mx-auto">
            <div className="animate-pulse flex flex-col">
                <div className="rounded-md bg-gray-400 h-52 w-full"></div>
                <div className="flex-1 space-y-4 py-1">
                    <div className="h-4 py-3 bg-gray-400 rounded w-3/4"></div>
                    <div className="h-4 bg-gray-400 rounded w-2/4"></div>
                    <div className="flex justify-between">
                        <div className="py-2 bg-gray-400 rounded w-24 "></div>
                        <div className="py-2 bg-gray-400 rounded w-24"></div>
                    </div>
                    <div className="py-4 bg-gray-400 rounded block "></div>
                </div>
            </div>
        </div>
    )
}

export default Placeholder
